/* eslint-disable no-unused-vars, no-console */

import { post_request, formatDocWithTimestamp } from './sharedFunctions';

export default {
    state: {
        userDoc: null,
        statusList: null,
        projectsList: null,
        selectedClient: null,
    },
    getters: {
        getTheme(state) {
            return state.userDoc.preference.theme;
        },
    },
    mutations: {
        setUserDoc(state, userDoc) {
            state.userDoc = userDoc;
        },
        setSelectedClient(state, client) {
            state.selectedClient = client;
        },
        updateColorScheme(state, myColor) {
            state.userDoc.preference.theme = myColor;
        },
    },
    actions: {
        async updateDoc({ dispatch }, dictionary) {
            await post_request('set-firestore-doc', {
                path: `${dictionary.path}`,
                doc_dict: dictionary.payload,
            });
        },
        async updateUserDoc({ dispatch }, dictionary) {
            dispatch('updateDoc', { path: `user/${dictionary.userId}`, payload: dictionary.payload });
        },
        async watchUserDoc({ rootState, commit }) {
            const userUid = rootState.auth.user ? rootState.auth.user.uid : null;
            if (userUid !== null) {
                await post_request('get-firestore-user-doc', {
                    path: `user/${userUid}`,
                })
                    .then((resp) => resp.json())
                    .then((data) => {
                        commit('setUserDoc', formatDocWithTimestamp(data.doc));
                    })
                    .catch((error) => console.log('Error getting userDoc', error));
            }
        },
        async getUserDoc({ rootState, commit }) {
            // This is a one-time fetch and not as useful as the watcher above
            const userUid = rootState.auth.user.uid ? rootState.auth.user.uid : '';
            const resp = await post_request('get-firestore-user-doc', { path: `user/${userUid}` });
            const data = await resp.json();
            const docSnap = await data.doc;

            if (docSnap) {
                commit('setUserDoc', formatDocWithTimestamp(docSnap));
            } else {
                console.log('No user document!');
                commit('setUserDoc', null);
            }
        },
        async updateClient({ commit }, client) {
            commit('setSelectedClient', client);
        },
        async updateLocalUserDoc({ commit }, doc) {
            commit('setUserDoc', doc);
        },
    },
};
